import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { Subscription, timer } from 'rxjs';
import { County } from 'src/app/model/county';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { QuestionHelpText } from 'src/app/model/question-help-text';
import { Region } from 'src/app/model/region.model';
import { School } from 'src/app/model/school.model';
import { Student } from 'src/app/model/student/student.model';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { PagingService } from 'src/app/service/paging.service';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { AcademicRiskReportResult } from './model/academic-risk-report-result.model';
import { AcademicRiskReportService } from './service/academic-risk-report.service';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ApiExportsService } from 'src/app/service/api-exports.service';
import { UrlProviderService } from 'src/app/service/urlprovider.service';
import { ProgressSpinnerSet, UtilityService } from 'src/app/service/utility.service';
import { ApiFetchExportDataService } from 'src/app/service/api-fetchexportdata.service';
import { Router } from '@angular/router';
import { ChildReportsService } from '../service/child-reports.service';
import { RegionDataService } from 'src/app/component/common-components/service/region-data.service';
import { RegionDropdownComponent } from '../../common-components/region/region-dropdown/region-dropdown.component';
import { DistrictDropdownComponent } from '../../common-components/district/district-dropdown/district-dropdown.component';
import { ThemePalette } from '@angular/material/core';
import { ChosenRegion, ChosenSchoolDistrict } from '../counts/model/student-eligibility-count';
import { CountyDropdownComponent } from '../../common-components/county/county-dropdown/county-dropdown.component';
import { SchoolDropdownComponent } from '../../common-components/school/school-dropdown/school-dropdown.component';
import { DistrictDataService } from '../../common-components/service/district-data.service';
import { SchoolDataService } from '../../common-components/service/school-data.service';

@Component({
    selector: 'academic-risk-report',
    templateUrl: './academic-risk-report.component.html',
    styleUrls: ['./academic-risk-report.component.scss']
})
export class AcademicRiskReportComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    @ViewChild('appRegionCode') appRegionCode!: RegionDropdownComponent;
    @ViewChild('appCountyCode') appCountyCode!: CountyDropdownComponent;
    @ViewChild('appSchoolsCode') appSchoolsCode!: SchoolDropdownComponent;
    @ViewChild('appSchoolDistrictCode') appSchoolDistrictCode!: DistrictDropdownComponent;
    @Input() searchParm: any = [{}];

    // Search variables
    selectedSchoolYear: string = '';
    selectedPerformancePeriod: string = '';
    initialPerformancePeriod: string = '';
    currentPerformancePeriod: string = '';
    allRegions: Region[] = [];
    allDistricts: SchoolDistrict[] = [];
    allSchools: School[] = [];
    lstSelectedRegion: Region[] = [];
    lstSelecteddistricts: SchoolDistrict[] = [];
    lstSelectedschools: School[] = [];
    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    chosenSchools: School[] = [];

    isExporting: boolean = false;
    hasExports: boolean = false;

    // Component variables
    resetField: boolean = false;
    progressCurrentValue: number = 10;
    progressValue: number = 10;
    progressMax: number = 200;
    progressSpinnerMax: number = 100;
    progressColor: ThemePalette = 'accent';
    progressType: ProgressSpinnerMode = 'determinate';
    progressSpeed: number = 50;
    progressSubscription: Subscription;
    progressInterval: number = 500;

    lstchosenSchoolDistrict: ChosenSchoolDistrict[] = [];
    lstchosenSchoolRegion: ChosenRegion[] = [];
    lstAcademicRiskResponse: AcademicRiskReportResult[];
    strExportFileName = 'Academic_Risk_Report';
    fileNameLabel: string = '';
    bCheckedStyling: boolean = true;

    // Table display
    baseDisplayedColumns: string[] = ['MSD_NUMBER', 'SSID', 'PERSON.LAST_NAME', 'GRADES', 'QAD'];
    caasppColumns: string[] = ['CAASPP_ELA_SCORE', 'CAASPP_MATH_SCORE'];
    celdtColumns: string[] = ['CELDT_SCORE'];
    elpacColumns: string[] = ['ELPAC_SCORE'];
    suffixColumns: string[] = ['EL_INDICATOR'];
    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns

    // Table results
    tableDataSources: MatTableDataSource<Student>[] = [];

    // Results
    results: AcademicRiskReportResult[] = [];
    displayName: string = '';
    filter: string = '';

    lstQuestionHelpText: QuestionHelpText[] = [];
    currentSetting: any;
    isLoadingResults: boolean = false;
    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();

    settings: any = {
        '/reports/academic-risk-report': {
            TITLE: 'Academic Risk Report',
            EXPORTFILENAME: 'Academic_Risk_Report',
            API: undefined,
            SCHOOL_YEAR: true,
            QUESTION_HELP_TEXT_ID: 248,
            COLUMN_HEADERS: [
                'School Year',
                'Region',
                'District',
                'School',
                'MSD Number',
                'SSID',
                'Name',
                'Grade',
                'QAD',
                'CAASPP ELA',
                'CAASPP Math',
                'ELPAC',
                'EL Status'
            ],
            COLUMN_WIDTHS: [52, 52, 52, 82, 82, 52, 52, 52, 52, 52, 82, 82, 52, 52],
            COLUMNS: [
                'SERVICE_CODE',
                'FEDERAL_CATEGORY',
                'FEDERAL_CATEGORY_CHILD',
                'SERVICE_CATEGORY',
                'PARTY_SERVICE_STATUS_TYPES_ID',
                'SERVICE_NAME',
                'MSD_NUMBER',
                'SSID',
                'PERSON.LAST_NAME',
                'GRADES',
                'QAD',
                'CAASPP_ELA_SCORE',
                'CAASPP_MATH_SCORE',
                'ELPAC_SCORE',
                'EL_INDICATOR'
            ]
        }
    };
    constructor(
        public pagingService: PagingService,
        private dialog: MatDialog,
        private academicRiskService: AcademicRiskReportService,
        private apiMsinExportsService: ApiExportsService,
        private urlProvider: UrlProviderService,
        private utilityService: UtilityService,
        private apiFetchExportDataService: ApiFetchExportDataService,
        router: Router,
        private childReportsService: ChildReportsService,
        private regionDataService: RegionDataService,
        private districtDataService: DistrictDataService,
        private schoolDataService: SchoolDataService
    ) {
        console.log('now connecting:');
        console.log(router.url);
        this.connectAPIs(childReportsService);
        this.selectSettings(router.url);
        console.log('currentSetting:');
        console.log(this.currentSetting);
        console.log(this.settings);
    }

    ngOnInit(): void {
        this.regionDataService.getAll().subscribe({
            next: (data: any) => {
                this.allRegions = data;
            },
            error: (error: any) => {
                console.error('Error fetching regions:', error);
            }
        });

        this.districtDataService.getAll().subscribe({
            next: (data: any) => {
                this.allDistricts = data;
                console.log('got all districts as: ');
                console.log(this.allDistricts);
            },
            error: (error: any) => {
                console.error('Error fetching districts:', error);
            }
        });

        this.schoolDataService.getAll().subscribe({
            next: (data: any) => {
                this.allSchools = data;
                console.log('got all schools as: ');
                console.log(this.allSchools);
            },
            error: (error: any) => {
                console.error('Error fetching schools:', error);
            }
        });
    }

    findSchoolIDForSchoolName(schoolName: string): number {
        let retId: number | undefined = -1;
        this.allSchools.forEach((school) => {
            if (school.NAME?.toLowerCase() === schoolName?.toLowerCase()) {
                retId = school.ID;
            }
        });
        return retId;
    }

    search() {
        if (this.checkValid()) {
            this.isLoading = true;
            this.msg = {};
            this.filter = '';

            this.academicRiskService
                .search(
                    this.toNumberArray(this.chosenRegions),
                    this.toNumberArray(this.chosenCounties),
                    this.toNumberArray(this.chosenSchoolDistricts),
                    this.toNumberArray(this.chosenSchools),
                    this.selectedPerformancePeriod
                )
                .subscribe({
                    next: (res) => {
                        if (res.regions) {
                            this.results = res.regions.sort((n1: AcademicRiskReportResult, n2: AcademicRiskReportResult) => (n1.CODE! > n2.CODE! ? 1 : -1));

                            let prefixColumns = ['SCHOOL.COUNTy.COUNTY_NAME', 'SCHOOL.SCHOOL_DISTRICT.DISTRICTS', 'SCHOOL.NAME'];
                            this.displayedColumns = this.generateDisplayColumns(this.selectedPerformancePeriod, prefixColumns);

                            this.displayName = this.results.length > 1 ? 'Regions' : 'Region';
                        } else if (res.counties) {
                            this.results = res.counties.sort((n1: AcademicRiskReportResult, n2: AcademicRiskReportResult) =>
                                n1.COUNTY_NAME! > n2.COUNTY_NAME! ? 1 : -1
                            );

                            let prefixColumns = ['SCHOOL.SCHOOL_DISTRICT.DISTRICTS', 'SCHOOL.NAME'];
                            this.displayedColumns = this.generateDisplayColumns(this.selectedPerformancePeriod, prefixColumns);

                            this.displayName = this.results.length > 1 ? 'School Districts' : 'School District';
                        } else if (res.schoolDistricts) {
                            this.results = res.schoolDistricts.sort((n1: AcademicRiskReportResult, n2: AcademicRiskReportResult) =>
                                n1.DISTRICTS! > n2.DISTRICTS! ? 1 : -1
                            );

                            let prefixColumns = ['SCHOOL.NAME'];
                            this.displayedColumns = this.generateDisplayColumns(this.selectedPerformancePeriod, prefixColumns);

                            this.displayName = this.results.length > 1 ? 'School Districts' : 'School District';
                        } else if (res.schools) {
                            this.results = res.schools.sort((n1: AcademicRiskReportResult, n2: AcademicRiskReportResult) =>
                                n1.SCHOOL_NAME! > n2.SCHOOL_NAME! ? 1 : -1
                            );

                            let prefixColumns = ['SCHOOL.NAME'];
                            this.displayedColumns = this.generateDisplayColumns(this.selectedPerformancePeriod, prefixColumns);

                            this.displayName = this.results.length > 1 ? 'Schools' : 'School';
                        } else if (res.msg) {
                            this.results = [];
                            this.msg = res.msg;
                        } else {
                            this.results = [];
                            this.msg = { SUCCESS: false, MSG: 'Error retrieving Academic Risk Report.' };
                        }
                    },
                    error: (err) => {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving Academic Risk Report.' };
                    },
                    complete: () => {
                        // Updates the Tables to be displayed w/ this.results
                        this.updateDataSource();

                        // Display current performance period
                        this.currentPerformancePeriod = this.selectedPerformancePeriod;

                        // Expand all
                        this.expandAll(this.results);

                        // Display results
                        this.isLoading = false;
                    }
                });
        }
    }

    generateDisplayColumns(schoolYear: string, prefixColumns?: string[]) {
        let displayedColumns: string[] = prefixColumns ? prefixColumns : [];

        displayedColumns = displayedColumns.concat(this.baseDisplayedColumns);

        displayedColumns = displayedColumns.concat(this.caasppColumns);

        if (parseInt(schoolYear.substring(0, 4)) >= 2016 && parseInt(schoolYear.substring(0, 4)) <= 2017) {
            displayedColumns = displayedColumns.concat(this.celdtColumns);
        }

        if (parseInt(schoolYear.substring(0, 4)) >= 2017) {
            displayedColumns = displayedColumns.concat(this.elpacColumns);
        }

        if (parseInt(schoolYear.substring(0, 4)) >= 2016) {
            displayedColumns = displayedColumns.concat(this.suffixColumns);
        }

        return displayedColumns;
    }

    generatePayload(): any {
        let payload: any = {};

        payload.chosenRegions = this.chosenRegions.map((obj) => obj.ID);
        payload.chosenCounties = this.chosenCounties.map((obj) => obj.ID);
        payload.chosenSchoolDistricts = this.chosenSchoolDistricts.map((obj) => obj.ID);
        payload.chosenSchools = this.chosenSchools.map((obj) => obj.ID);
        payload.performancePeriod = this.selectedPerformancePeriod;

        return payload;
    }

    connectAPIs(childReportsService: ChildReportsService) {
        this.settings['/reports/academic-risk-report'].API = function (payload: any) {
            return childReportsService.getAcademicRiskSearch(payload);
        };
    }

    selectSettings(url: string) {
        this.currentSetting = this.settings[url];
    }

    updateDataSource() {
        this.tableDataSources = [];

        setTimeout(() => {
            this.results.forEach((result, index) => {
                // Data
                let dataSource = new MatTableDataSource<Student>();
                dataSource.data = result.STUDENTS!;

                // Paginator
                dataSource.paginator = this.paginators.toArray()[index];

                // Sort
                dataSource.sort = this.sorts.toArray()[index];
                const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
                dataSource.sort.active = defaultSort.active;
                dataSource.sort.direction = defaultSort.direction;
                dataSource.sort.sortChange.emit(defaultSort);
                dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

                // Filter
                dataSource.filterPredicate = (data: any, filter) => {
                    const dataStr = JSON.stringify(data).toLowerCase();
                    return dataStr.indexOf(filter) != -1;
                };

                this.tableDataSources.push(dataSource);
            });
        });
    }

    setFilter() {
        this.tableDataSources.forEach((dataSource, index) => {
            dataSource.filter = this.filter.trim().toLocaleLowerCase();
        });
    }

    checkValid() {
        if (this.chosenRegions.length > 0 && this.selectedPerformancePeriod) {
            return true;
        }

        return false;
    }

    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }

    performancePeriodEvent(performancePeriod: string) {
        this.selectedPerformancePeriod = performancePeriod;
    }

    // MISC
    reset() {
        this.resetField = !this.resetField;
        //This is optional code To resetthe value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        this.chosenRegions = [];
        this.chosenCounties = [];
        this.chosenSchoolDistricts = [];
        this.chosenSchools = [];
        this.msg = {};
    }

    hasChild = (_: number, node: AcademicRiskReportResult) => !!node.STUDENTS && node.STUDENTS.length > 0;

    expandAll(array: any[]) {
        array.forEach((obj) => {
            obj.SHOW = true;
        });
    }

    collapseAll(array: any[]) {
        array.forEach((obj) => {
            obj.SHOW = false;
        });
    }

    toggleShow(obj: any) {
        obj.SHOW = !obj.SHOW;
    }

    announceSortChange(sortState: Sort) {}

    isQadExpired(d: string) {
        if (moment(d).isValid()) {
            let qad = new Date(moment(d).format('LL'));
            let expiredDay = new Date(qad.getFullYear() + 3, qad.getMonth(), qad.getDate());
            const today = new Date(moment().format('LL'));

            if (expiredDay < today) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    fnInitializeProgressSpinner(iCount: number, isPdf: boolean) {
        this.progressMax = iCount;
        let numResults: ProgressSpinnerSet = {
            progressMax: this.progressMax,
            progressCurrentValue: this.progressCurrentValue,
            progressValue: this.progressValue,
            progressSpeed: this.progressSpeed,
            isPdf: isPdf
        };
        this.utilityService.fnPrepProgressSpinner(numResults);
        this.progressMax = numResults.progressMax;
        this.progressCurrentValue = numResults.progressCurrentValue;
        this.progressValue = numResults.progressValue;
        this.progressSpeed = numResults.progressSpeed;
    }

    downloadXLS(schoolName?: string) {
        console.log('now downloading xls data');
        //this.isExporting = true;
        //this.isLoadingResults = true;
        console.log('now download xls');
        console.log(this.tableDataSources[0].data);
        console.log('using schoolName:');
        console.log(schoolName);
        setTimeout(() => {
            this.downloadXLSCore(false, schoolName);
        }, 100);
    }

    downloadXLSCore(bViaPost: boolean, schoolName?: string) {
        console.log('now downstreaming XLS file :');

        this.lstAcademicRiskResponse = this.tableDataSources[0].data;
        console.log('with rows:');
        console.log(this.lstAcademicRiskResponse);
        console.log('with school:');
        console.log(schoolName);
        console.log('and schoolyear:');
        console.log(this.currentPerformancePeriod);
        if (schoolName) {
            this.fileNameLabel = schoolName;
        }
        this.isExporting = true;
        this.progressMax = this.lstAcademicRiskResponse.length;
        console.log('set progressMax at:');
        console.log(this.progressMax);
        this.progressValue = 10;
        this.progressCurrentValue = 10;
        this.progressValue = (1 / this.progressMax) * 100;

        console.log('initial progressValue=');
        console.log(this.progressValue);
        console.log('creating school from: ');
        console.log(this.appSchoolsCode?.selectedSchoolIds);
        console.log('creating school districts from: ');
        console.log(this.appSchoolDistrictCode?.selectedSchoolDistrictIds);

        this.lstSelectedRegion = this.appRegionCode?.selectedRegionIds?.map((num: number) => this.utilityService.CreateRegionFromNumber(num));
        this.lstSelecteddistricts = this.appSchoolDistrictCode?.selectedSchoolDistrictIds?.map((num: number) =>
            this.utilityService.CreateSchoolDistrictFromNumber(num)
        );
        this.lstSelectedschools = this.appSchoolsCode?.selectedSchoolIds.map((num: number) => this.utilityService.CreateSchoolFromNumber(num));

        this.searchParm.bCheckedStyling = this.bCheckedStyling.toString();
        this.strExportFileName = this.currentSetting?.EXPORTFILENAME ?? '';
        let strTemplateName = this.strExportFileName;
        this.searchParm.strExportType = 'XLS';

        try {
            this.lstAcademicRiskResponse = this.tableDataSources.map((item) => item.data).reduce((acc, val) => acc.concat(val), []);

            this.searchParm = this.generatePayload();
            this.searchParm.lstSelectedRegion = JSON.stringify(this.lstSelectedRegion);
            this.searchParm.chosenRegions = this.allRegions.find((region) => region.CODE === this.appRegionCode?.selectedRegionIds[0].toString()); // this.appRegionCode?.selectedRegionIds?.map((num:number) => this.utilityService.CreateRegionFromNumber(num));
            this.searchParm.chosenCounties = this.appCountyCode?.selectedCountyIds.map((num: number) => this.utilityService.CreateCountyFromNumber(num));
            this.searchParm.chosenSchools = this.appSchoolsCode?.selectedSchoolIds.map((num: number) => this.utilityService.CreateSchoolFromNumber(num));
            this.selectedSchoolYear = this.currentPerformancePeriod;

            this.searchParm.chosenSchoolDistricts = this.allDistricts.find(
                (district) => district.DISTRICTS === this.appSchoolDistrictCode?.selectedSchoolDistrictName?.toString()
            ); //this.lstSelecteddistricts;
            this.searchParm.schoolYear = this.selectedSchoolYear;
            this.searchParm.schools = this.lstAcademicRiskResponse;
            this.searchParm.Template_Name = strTemplateName;

            this.searchParm.strFileName = strTemplateName;
            this.searchParm.fileNameLabel = this.fileNameLabel;
            this.searchParm.bCheckedStyling = this.bCheckedStyling.toString();

            this.searchParm.columns = this.currentSetting?.COLUMNS;
            this.searchParm.columnHeaders = this.currentSetting?.COLUMN_HEADERS ?? 0;
            this.searchParm.columnWidths = this.currentSetting?.COLUMN_WIDTHS ?? 0;
            this.searchParm.file_name_label = this.currentSetting?.TITLE ?? '';
            this.searchParm.reportType = 0;
            this.searchParm.strExportType = 'XLS';
            this.searchParm.isChosenSchool = false;

            setTimeout(() => {
                console.log('passing searchParm');
                console.log(this.searchParm);

/*
                const progressInterval = setInterval(() => {
                    if (this.progressCurrentValue <= this.progressSpinnerMax) {
                        // this corresponds to 100% of the spinner rotation
                        this.progressCurrentValue += 1;
                        this.progressValue = (this.progressCurrentValue / this.progressMax) * 100;
                         console.log("cur value is: ")
                            console.log(this.progressValue)
                            console.log(this.progressCurrentValue)
                    } else {
                        this.isExporting = false;
                        clearInterval(progressInterval);
                    }
                }, this.progressSpeed); // spinner speed, smaller value=faster
*/
                let chosenRegions: number[] = this.chosenRegions.map((item) => item.ID ?? 0);
                let chosenCounties: number[] = this.chosenCounties.map((item) => item.ID ?? 0);
                let chosenSchoolDistricts: number[] = this.chosenSchoolDistricts.map((item) => item.ID ?? 0);
                let chosenSchools: number[] = this.chosenSchools.map((item) => item.ID ?? 0);

                var params = {
                    chosenRegions: chosenRegions,
                    chosenCounties: chosenCounties,
                    chosenSchoolDistricts: chosenSchoolDistricts,
                    chosenSchools: chosenSchools,
                    performancePeriod: this.currentPerformancePeriod //this.searchParm.schoolYear,
                    /*expiredEligibility: this.expiredEligibility,
	                        expiredQAD: this.expiredQAD,
	                        grades: this.grades,
	                        partyServices: this.partyServices,
	                        enrollmentPeriods: this.enrollmentPeriods*/
                };

                this.searchParm.chosenRegions = params.chosenRegions;
                this.searchParm.chosenCounties = params.chosenCounties;
                this.searchParm.chosenSchools = params.chosenSchools;
                if (schoolName) {
                    let chosenSchoolID: number;
                    chosenSchoolID = this.findSchoolIDForSchoolName(schoolName);

                    console.log('Found schoolID for school:');
                    console.log(chosenSchoolID);

                    if (chosenSchoolID) {
                        this.searchParm.chosenSchools = [chosenSchoolID];
                        console.log('chosenSchools set to new deal');
                    }

                    this.searchParm.isChosenSchool = true;
                }
                this.searchParm.performancePeriod = params.performancePeriod;

                this.apiMsinExportsService.getAcademicRiskPost(this.searchParm).then(()=> {
                     this.isExporting = false;
                    })
                    .finally(()=>{
                        this.isExporting = false;
                        console.log('hid spinner3');
                    });
				}),
                (error: any) => {
                    console.log('Error fetching student data counts:', error);
                    this.isExporting = false;
                };

        } catch (Err) {
            console.log('Error running filestream XLS export: ');
            console.log(Err);
            this.isExporting = false; // hide spinner
        }
    }

    downloadPDF(schoolName?: string) {
        this.downloadPdfCore(false, schoolName);
    }

    downloadPdfCore(bRegional: boolean, schoolName?: string) {
        console.log('now downstreaming PDF file');

        this.lstAcademicRiskResponse = this.tableDataSources[0].data;

        console.log('with rows:');
        console.log(this.lstAcademicRiskResponse);
        console.log('with school:');
        console.log(schoolName);
        this.isExporting = true;
        this.progressMax = this.lstAcademicRiskResponse.length;
        console.log('set progressMax at:');
        console.log(this.progressMax);
        console.log('schoolyears passed:');
        console.log(this.selectedSchoolYear);
        console.log(this.selectedPerformancePeriod);
        this.progressValue = 10;
        this.progressCurrentValue = 10;
        this.progressValue = (1 / this.progressMax) * 100;

        console.log('initial progressValue=');
        console.log(this.progressValue);
        console.log('creating school from: ');
        console.log(this.appSchoolsCode?.selectedSchoolIds);
        console.log('creating school districts from: ');
        console.log(this.appSchoolDistrictCode?.selectedSchoolDistrictIds);

        this.lstSelectedRegion = this.appRegionCode?.selectedRegionIds?.map((num: number) => this.utilityService.CreateRegionFromNumber(num));
        this.lstSelecteddistricts = this.appSchoolDistrictCode?.selectedSchoolDistrictIds?.map((num: number) =>
            this.utilityService.CreateSchoolDistrictFromNumber(num)
        );
        this.lstSelectedschools = this.appSchoolsCode?.selectedSchoolIds.map((num: number) => this.utilityService.CreateSchoolFromNumber(num));
        this.searchParm.bCheckedStyling = this.bCheckedStyling.toString();
        this.strExportFileName = this.currentSetting?.EXPORTFILENAME ?? '';
        let strTemplateName = this.strExportFileName;
        this.searchParm.strExportType = 'PDF';

        try {
            this.lstAcademicRiskResponse = this.tableDataSources.map((item) => item.data).reduce((acc, val) => acc.concat(val), []);

            this.searchParm = this.generatePayload();
            this.searchParm.lstSelectedRegion = JSON.stringify(this.lstSelectedRegion);
            this.searchParm.chosenRegions = this.allRegions.find((region) => region.CODE === this.appRegionCode?.selectedRegionIds[0].toString()); // this.appRegionCode?.selectedRegionIds?.map((num:number) => this.utilityService.CreateRegionFromNumber(num));
            this.searchParm.chosenCounties = this.appCountyCode?.selectedCountyIds.map((num: number) => this.utilityService.CreateCountyFromNumber(num));
            this.searchParm.chosenSchools = this.appSchoolsCode?.selectedSchoolIds.map((num: number) => this.utilityService.CreateSchoolFromNumber(num));
            this.searchParm.chosenSchoolDistricts = this.allDistricts.find(
                (district) => district.DISTRICTS === this.appSchoolDistrictCode?.selectedSchoolDistrictName?.toString()
            ); //this.lstSelecteddistricts;
            this.searchParm.schoolYear = this.selectedPerformancePeriod;
            this.searchParm.schools = this.lstAcademicRiskResponse;
            this.searchParm.Template_Name = strTemplateName;

            this.searchParm.strFileName = strTemplateName;
            this.searchParm.fileNameLabel = this.fileNameLabel;
            this.searchParm.bCheckedStyling = this.bCheckedStyling.toString();

            this.searchParm.columns = this.currentSetting?.COLUMNS;
            this.searchParm.columnHeaders = this.currentSetting?.COLUMN_HEADERS ?? 0;
            this.searchParm.columnWidths = this.currentSetting?.COLUMN_WIDTHS ?? 0;
            this.searchParm.file_name_label = this.currentSetting?.TITLE ?? '';
            this.searchParm.reportType = 1;
            this.searchParm.strExportType = 'PDF';

            setTimeout(() => {
                console.log('passing searchParm');
                console.log(this.searchParm);
                this.isExporting = true;
                const progressInterval = setInterval(() => {
                    if (this.progressCurrentValue <= this.progressSpinnerMax) {
                        // this corresponds to 100% of the spinner rotation
                        this.progressCurrentValue += 1;
                        this.progressValue = (this.progressCurrentValue / this.progressMax) * 100;
                        /* console.log("cur value is: ")
                                console.log(this.progressValue)
                                console.log(this.progressCurrentValue)*/
                    } else {
                        this.isExporting = false;
                        clearInterval(progressInterval);
                    }
                }, this.progressSpeed); // spinner speed, smaller value=faster

                let chosenRegions: number[] = this.chosenRegions.map((item) => item.ID ?? 0);
                let chosenCounties: number[] = this.chosenCounties.map((item) => item.ID ?? 0);
                let chosenSchoolDistricts: number[] = this.chosenSchoolDistricts.map((item) => item.ID ?? 0);
                let chosenSchools: number[] = this.chosenSchools.map((item) => item.ID ?? 0);

                var params = {
                    chosenRegions: chosenRegions,
                    chosenCounties: chosenCounties,
                    chosenSchoolDistricts: chosenSchoolDistricts,
                    chosenSchools: chosenSchools,
                    performancePeriod: this.searchParm.schoolYear
                    /*expiredEligibility: this.expiredEligibility,
	                        expiredQAD: this.expiredQAD,
	                        grades: this.grades,
	                        partyServices: this.partyServices,
	                        enrollmentPeriods: this.enrollmentPeriods*/
                };
                this.searchParm.chosenRegions = params.chosenRegions;
                this.searchParm.chosenCounties = params.chosenCounties;
                this.searchParm.chosenSchools = params.chosenSchools;
                if (schoolName) {
                    let chosenSchoolID: number;
                    chosenSchoolID = this.findSchoolIDForSchoolName(schoolName);

                    console.log('Found schoolID for school:');
                    console.log(chosenSchoolID);

                    if (chosenSchoolID) {
                        this.searchParm.chosenSchools = [chosenSchoolID];
                        console.log('chosenSchools set to new deal');
                    }
                }
                this.searchParm.performancePeriod = params.performancePeriod;
                console.log('now calling http post with params:');
                console.log(params);
                this.apiMsinExportsService.getAcademicRiskPost(this.searchParm);
            });
        } catch (Err) {
            console.log('Error running filestream PDF export: ');
            console.log(Err);
            //console.log("hid spinner2")
            this.isExporting = false;
        }
    }
}
